<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row v-for="n in 3" :key="`line_${n}`">
        <v-col v-for="item in 3" :key="`column_${item}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-skeleton-loader class="mx-auto" type="list-item" />
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4 mb-4" v-if="!edicao">Cadastro de Pesquisa de Satisfação</div>
      <v-form ref="form">
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              :disabled="permissaoVisualizar"
              outlined
              dense
              label="Descrição"
              :counter="30"
              v-model="form.description"
              :error-messages="descriptionErrors"
              @input="$v.form.description.$touch()"
              @blur="$v.form.description.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :disabled="permissaoVisualizar"
              outlined
              dense
              label="Quantidade de Dígitos"
              type="number"
              v-model="form.quantidadeDigitos"
              :error-messages="quantidadeDigitosErrors"
              @input="$v.form.quantidadeDigitos.$touch()"
              @blur="$v.form.quantidadeDigitos.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :disabled="permissaoVisualizar"
              outlined
              dense
              label="Tempo de espera"
              type="number"
              v-model="form.tempoEspera"
              :error-messages="tempoEsperaErrors"
              @input="$v.form.tempoEspera.$touch()"
              @blur="$v.form.tempoEspera.$touch()"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              :disabled="permissaoVisualizar"
              outlined
              dense
              label="Quantidade de loops"
              type="number"
              v-model="form.quantidadeLoops"
              :error-messages="quantidadeLoopsErrors"
              @input="$v.form.quantidadeLoops.$touch()"
              @blur="$v.form.quantidadeLoops.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              outlined
              dense
              label="Áudio início"
              :items="audios"
              v-model="form.audioInicio"
              :disabled="permissaoVisualizar"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              outlined
              dense
              label="Áudio fim"
              :items="audios"
              v-model="form.audioFim"
              :disabled="permissaoVisualizar"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="4">
            <v-select
              :disabled="permissaoVisualizar"
              outlined
              dense
              label="Áudio pesquisa"
              :items="audios"
              v-model="form.audioPesquisa"
              :error-messages="audioPesquisaErrors"
              @input="$v.form.audioPesquisa.$touch()"
              @blur="$v.form.audioPesquisa.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              outlined
              dense
              label="Áudio erro"
              :items="audios"
              v-model="form.audioErro"
              :disabled="permissaoVisualizar"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              outlined
              dense
              label="Áudio Aviso Gravação"
              :items="audios"
              v-model="form.audioAvisoGravacao"
              :disabled="permissaoVisualizar"
            />
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <div class="text-h4 mb-4">Métricas</div>

        <v-row v-for="n in qtdMetricas" :key="`metrica_${n}`" align="baseline" dense>
          <v-col cols="4">
            <v-text-field
              dense
              v-model="metricSelected[n - 1]"
              outlined
              label="Descrição métrica"
              :disabled="permissaoVisualizar"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              v-model="noteSelected[n - 1]"
              type="number"
              outlined
              label="Nota"
              :disabled="permissaoVisualizar"
            />
          </v-col>
          <div >
            <v-tooltip top >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  dark
                  fab
                  :color="colorSelected[n - 1] || 'grey lighten-1'"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogColor(n - 1)"
                  
                >
                  <v-icon>mdi-format-color-highlight</v-icon>
                </v-btn>
              </template>
              <span>Selecionar Cor</span>
            </v-tooltip>

            <v-dialog v-model="colorPicker" width="600">
              <v-card :disabled="permissaoVisualizar">
                <v-card-title>Selecione a Cor Desta Nota</v-card-title>

                <v-divider />

                <div class="color-picker-container">
                  <v-color-picker
                    swatches-max-height="200"
                    show-swatches
                    hide-mode-switch
                    hide-canvas
                    hide-inputs
                    hide-sliders
                    elevation="4"
                    v-model="color"
                  />
                </div>

                <v-divider />

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" text @click="updateMetricColor">
                    Concluir
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-col cols="2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small dark icon color="bluePcm" v-bind="attrs" v-on="on" @click="qtdMetricas += 1 " :disabled="permissaoVisualizar">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Nova Metrica</span>
            </v-tooltip>
            <v-tooltip top v-if="n - 1 !== 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small dark icon color="darkRed" v-bind="attrs" v-on="on" @click="removeMetrica(n - 1)" :disabled="permissaoVisualizar">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover Metrica</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
      <FixedButtons
        @salvar="salvar"
        @cancelar="cancelar"
        :pararLoader="pararLoader"
        :disableSaveButton="permissaoVisualizar"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import pesquisaSatisfacaoStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import pesquisaSatisfacaoHttpService from '../_services/pesquisaSatisfacaoHttpService'

export default {
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, FixedButtons },

  data: () => ({
    form: {
      description: '',
      quantidadeDigitos: '',
      tempoEspera: '',
      quantidadeLoops: '',
      audioInicio: '',
      audioFim: '',
      audioPesquisa: '',
      audioErro: '',
      audioAvisoGravacao: '',
      metricas: {},
    },
    type: 'hex',
    hex: '#FF00FF',
    audios: [{ text: '', value: '' }],
    text: '',
    qtdMetricas: 1,
    metricSelected: [],
    noteSelected: [],
    colorSelected: [],
    colorPicker: false,
    snackbar: false,
    showSkeleton: false,
    pararLoader: {
      parar: false,
    },
    permissaoVisualizar: false,
    colorPosition: 0,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('cadastroPesquisaSatisfacaoModulePesquisaSatisfacaoStore', [
      'getPesquisaSatisfacaoEspecifica',
      'getAudios',
    ]),
    color: {
      get() {
        return this[this.type]
      },
      set(v) {
        this[this.type] = v
      },
    },
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'cadastroPesquisaSatisfacaoModulePesquisaSatisfacaoStore', pesquisaSatisfacaoStore)

    await this.listarAudios()
    this.audios = [...this.audios, ...this.getAudios.map(audio => ({ text: audio.description, value: audio._id }))]

    if (this.edicao === 'true') {
      this.form = this.getPesquisaSatisfacaoEspecifica

      this.qtdMetricas = Object.keys(this.getPesquisaSatisfacaoEspecifica.metricas).length
      this.noteSelected = Object.keys(this.getPesquisaSatisfacaoEspecifica.metricas)

      const metricData = Object.values(this.getPesquisaSatisfacaoEspecifica.metricas)
      this.metricSelected = metricData.map(metric => metric.description)
      this.colorSelected = metricData.map(metric => metric.color)
    }

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    if (arrayPermissions.includes(process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_VISUALIZAR_CONDICIONADO)) {
      this.permissaoVisualizar = true
    }

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('cadastroPesquisaSatisfacaoModulePesquisaSatisfacaoStore', ['listarAudios']),
    ...obtainUserPermissions,

    openDialogColor(colorArrayPosition) {
      this.colorPosition = colorArrayPosition

      this.colorPicker = true
    },

    updateMetricColor() {
      this.colorSelected[this.colorPosition] = this.color

      this.colorPicker = false
    },

    async salvar() {
      this.pararLoader.parar = false

      if (this.metricSelected.length !== this.noteSelected.length) {
        this.text = 'Todas as métricas devem ter nota'
        this.pararLoader.parar = true
        this.snackbar = true
        return
      }

      const temChavesDuplicadas = new Set(this.noteSelected).size !== this.noteSelected.length
      if (temChavesDuplicadas) {
        this.text = 'Não é possível repetir notas'
        this.pararLoader.parar = true
        this.snackbar = true
        return
      }

      if (this.metricSelected.length === 0 || this.noteSelected.length === 0) {
        this.text = 'Definir ao menos uma métrica com nota.'
        this.pararLoader.parar = true
        this.snackbar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      let metrics = {}
      for (let i = 0; i < this.metricSelected.length; i++) {
        let metric = {}

        metric.description = this.metricSelected[i]
        metric.color = this.colorSelected[i] ? this.colorSelected[i] : '#BDBDBD'
        
        metrics[`${this.noteSelected[i]}`] = metric

        // console.log(metrics, "metrics")

        this.form.metricas = metrics

        // this.form.metricas[`${this.noteSelected[i]}`] = {}

        // this.form.metricas[`${this.noteSelected[i]}`].description = this.metricSelected[i]
        // this.form.metricas[`${this.noteSelected[i]}`].color = this.colorSelected[i] ? this.colorSelected[i] : '#BDBDBD'
      }

      try {
        if (this.edicao === 'true') {
          await pesquisaSatisfacaoHttpService.putPesquisaSatisfacao(this._id, this.form)
        } else {
          await pesquisaSatisfacaoHttpService.postPesquisaSatisfacao(this.form)
        }
        this.$router.push({ name: 'cadastroPesquisa' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'cadastroPesquisa' })
    },
    removeMetrica(key) {
      this.qtdMetricas -= 1
      this.metricSelected.splice(key, 1)
      this.noteSelected.splice(key, 1)
    },
  },
}
</script>

<style scoped>
.color-picker-container {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
</style>
